import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { IndividualName } from './IndividualName.js';
import { EmailDetails } from './individuals/EmailDetails.js';
import { PhoneDetails } from './individuals/PhoneDetails.js';
export class SetIndividualPersonalDetailsRequest extends BaseMessage {
    id;
    name;
    birthDate;
    owner;
    emailDetails;
    phoneDetails;
}
__decorate([
    Field.string({
        description: 'Id of an individual',
        required: true,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], SetIndividualPersonalDetailsRequest.prototype, "id", void 0);
__decorate([
    Field.message({
        description: 'Name of the individual',
        required: false,
    }),
    __metadata("design:type", IndividualName)
], SetIndividualPersonalDetailsRequest.prototype, "name", void 0);
__decorate([
    Field.string({
        description: 'Birth date of an individual',
        required: false,
        format: 'date',
    }),
    __metadata("design:type", String)
], SetIndividualPersonalDetailsRequest.prototype, "birthDate", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], SetIndividualPersonalDetailsRequest.prototype, "owner", void 0);
__decorate([
    Field.message({
        description: 'Email of an individual',
    }),
    __metadata("design:type", EmailDetails)
], SetIndividualPersonalDetailsRequest.prototype, "emailDetails", void 0);
__decorate([
    Field.message({
        description: 'Phone number of an individual',
    }),
    __metadata("design:type", PhoneDetails)
], SetIndividualPersonalDetailsRequest.prototype, "phoneDetails", void 0);
//# sourceMappingURL=SetIndividualPersonalDetailsRequest.js.map